import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import type { RetainedBeaconChoice, RetainedBeaconEligibility } from '@/hooks/useRetainedBeaconDischarge';
import { RetainedBeaconDischargeChoice } from './RetainedBeaconDischargeChoice';

interface Props {
  open: boolean;
  eligibility?: RetainedBeaconEligibility | null;
  onContinue: (choice: RetainedBeaconChoice) => void;
  onCancel: () => void;
}

export function RetainedBeaconChoiceDialog({ open, eligibility, onContinue, onCancel }: Props) {
  const [choice, setChoice] = useState<RetainedBeaconChoice | null>(null);

  useEffect(() => {
    if (!open) setChoice(null);
  }, [open]);

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth aria-labelledby="retained-beacon-choice-title">
      <DialogTitle id="retained-beacon-choice-title">Confirm Discharge</DialogTitle>
      <DialogContent>
        <RetainedBeaconDischargeChoice value={choice} onChange={setChoice} eligibility={eligibility} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary">
          Cancel
        </Button>
        <Button onClick={() => choice && onContinue(choice)} color="primary" disabled={!choice}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
